import React from 'react';
import useLanguage from '../../hooks/useLanguage';

/**
 * ProductFilter Component
 * Category filter tabs for filtering products
 */
const ProductFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  const { language } = useLanguage();

  const allLabel = language === 'ko' ? '전체' : 'All';

  return (
    <div className="flex flex-wrap gap-3 justify-center mb-8">
      {/* All Categories Button */}
      <button
        onClick={() => onSelectCategory('all')}
        className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
          selectedCategory === 'all'
            ? 'bg-blue-600 text-white shadow-md'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        {allLabel}
      </button>

      {/* Category Buttons */}
      {categories.map((category) => (
        <button
          key={category.value}
          onClick={() => onSelectCategory(category.value)}
          className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
            selectedCategory === category.value
              ? 'bg-blue-600 text-white shadow-md'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          {language === 'ko' ? category.label : category.labelEn}
        </button>
      ))}
    </div>
  );
};

export default ProductFilter;
